export default __webpack_public_path__ + "static/media/Comp 2_00024.df9b906c.png";